import React from 'react';
import { Health_checks_headers, Vaccination_headers, Fitness_headers, Health_coach_headers, Spending_account_headers, Pharmacy_headers } from './tableHeaders';
import { healthCoachSchema, fitnessSchema, vaccinationSchema, spendingAccountSchema, healthChecksSchema } from '../schemas/table'

const HEALTH_CHECKS_LOW = {
  heading: 'Minimum 1% Employee Usage is Required to Show insights',
  body: 'This section shows the utilization of Health checks by employees and their dependents',
  type: 'health checks',
};

const DENTAL_LOW = {
  heading: 'Minimum 1% Employee Usage is Required to Show insights',
  body: 'This section shows the utilization of Dental checks by employees and their dependents',
  type: 'dental checks',
};

const VISION_LOW = {
  heading: 'Minimum 1% Employee Usage is Required to Show insights',
  body: 'This section shows the utilization of Vision checks by employees and their dependents',
  type: 'vision checks',
};

const DOCTOR_CONSULTATION_LOW = {
  heading: 'Minimum of 15 consultations have to be taken to show insights',
  body: 'This section shows the overall utilization of the doctor consultation',
  type: 'doctor consultation',
};

const HRA_LOW = {
  heading: 'Minimum 1% of Employees needs to complete the HRA for wellness insights to be shown',
  body: 'This section shows the health risk assessment utilization. By taking HRA a wellness score is generated for each employees and is then aggregated to provide a company wellness score',
  type: 'HRA',
};
const PHARMACY_LOW = {
  heading: 'Minimum of 20 orders have to be placed to show insights',
  body: 'This section shows the utilization of pharmacy including prescription and OTC medication',
  type: 'pharmacy',
};
const VACCINATION_LOW = {
  heading: 'Minimum 1% of employee needs to be vaccinated',
  body: 'This section shows the utilization of the vaccination sponsored by the company or paid by the employees',
  type: 'vaccination',
};
const FITNESS_LOW = {
  heading: 'Minimum of 15 Bookings have to be done to show insights',
  body: 'This section shows the utilization of the workout sessions sponsored by the company or paid by the employees',
  type: 'gym & fitness',
};
const HEALTH_COACH_LOW = {
  heading: 'Minimum 10 Enrollments have to be done to show insights',
  body: 'This section shows the utilization of care management programs and pregnancy care management',
  type: 'health coach',
};

const ACTIVITY_INITIAL_STATE = (benefitName) => ({
  ahc: {
    breadcrumb: {
      text: 'Health Checks',
      link: '/utilization/ahc',
    },
    heading: 'Activity log of health checks',
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  nhc: {
    breadcrumb: {
      text: 'NHC',
      link: '/utilization/nhc',
    },
    heading: `Activity log of ${benefitName || 'NHC'}`,
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  cancer_screening: {
    breadcrumb: {
      text: 'Cancer Screening',
      link: '/utilization/cancer_screening',
    },
    heading: 'Activity log of cancer screening',
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  fertility_treatment: {
    breadcrumb: {
      text: 'Fertility Treatment',
      link: '/utilization/fertility_treatment',
    },
    heading: 'Activity log of fertility treatment',
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  inclinic_consultation: {
    breadcrumb: {
      text: 'Inclinic Consultation',
      link: '/utilization/inclinic_consultation',
    },
    heading: 'Activity log of inclinic consultation',
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  consultation: {
    breadcrumb: {
      text: 'Consultation',
      link: '/utilization/consultation',
    },
    heading: 'Activity log of consultation',
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  covid_vaccination: {
    breadcrumb: {
      text: 'Covid Vaccination',
      link: '/utilization/covid_vaccination',
    },
    heading: 'Activity log of covid vaccination',
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  flu_vaccination: {
    breadcrumb: {
      text: 'Flu Vaccination',
      link: '/utilization/flu_vaccination',
    },
    heading: 'Activity log of flu vaccination',
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  specialist_consultation: {
    breadcrumb: {
      text: 'Online Specialist Consultation',
      link: '/utilization/specialist_consultation',
    },
    heading: 'Activity log of specialist consultation',
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  occupational_medical_rooms: {
    breadcrumb: {
      text: 'Occupational Medical Rooms',
      link: '/utilization/occupational_medical_rooms',
    },
    heading: 'Activity log of occupational medical rooms',
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  vaccination: {
    breadcrumb: {
      text: 'Vaccination',
      link: '/vaccination',
    },
    heading: 'Activity log of Vaccination',
    headers: Vaccination_headers,
    tableschema: vaccinationSchema,
    str: 'vaccination/raw',
  },
  spending_account: {
    breadcrumb: {
      text: 'Spending Account',
      link: '/spending-account',
    },
    heading: 'Activity log of Spending account',
    headers: Spending_account_headers,
    tableschema: spendingAccountSchema,
    str: 'spending_account/health_checks/mis',
  },
  fitness: {
    breadcrumb: {
      text: 'Gyms and Fitness',
      link: '/gym-and-fitness',
    },
    heading: 'Activity log of Gyms and Fitness',
    headers: Fitness_headers,
    tableschema: fitnessSchema,
    str: 'fitness/activity_log',
  },
  health_coach: {
    breadcrumb: {
      text: 'Health Coach',
      link: '/health-coach-programs',
    },
    heading: 'Activity log of Health Coach',
    headers: Health_coach_headers,
    tableschema: healthCoachSchema,
    str: 'health_coach/activity_log',
  },
  dental: {
    breadcrumb: {
      text: 'Dental Checks',
      link: '/utilization/dental',
    },
    heading: 'Activity log of dental checks',
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  vision: {
    breadcrumb: {
      text: 'Vision Checks',
      link: '/utilization/vision',
    },
    heading: 'Activity log of vision checks',
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  combined_vision_items: {
    breadcrumb: {
      text: 'Combined Vision Items',
      link: '/utilization/combined_vision_items',
    },
    heading: 'Activity log of combined vision items',
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  pre_employment: {
    breadcrumb: {
      text: 'Pre employment Checks',
      link: '/utilization/pre_employment',
    },
    heading: 'Activity log of pre employment checks',
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  physiotherapy: {
    breadcrumb: {
      text: 'Physiotherapy',
      link: '/utilization/physiotherapy',
    },
    heading: `Activity log of ${benefitName || 'physiotherapy'}`,
    headers: Health_checks_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
  pharmacy: {
    breadcrumb: {
      text: 'Pharmacy',
      link: '/pharmacy',
    },
    heading: 'Activity log of pharmacy',
    headers: Pharmacy_headers,
    tableschema: healthChecksSchema,
    str: 'raw',
  },
});

const AHC_LOCK_CONTENT = [
  <span>
    <span className='font-semibold'>Save up-to 40% on health checks</span> & create customized packages for your
    employees and dependents.
  </span>,
  <span>
    <span className='font-semibold'>The health checks can be availed at home, diagnostic center or a camp</span> can be
    set up at your office premises.
  </span>,
  <span>
    Our network is of <span className='font-semibold'>1000+ strong diagnostic centers.</span> Offering home collection
    in <span className='font-semibold'>more than 150 cities.</span> All our partners are{' '}
    <span className='font-semibold'>NABL / NABH accredited.</span>
  </span>,
];

const VISION_LOCK_CONTENT = [
  <span>
    <span className='font-semibold'>Save up-to 40% on vision checks</span> & create customized packages for your
    employees and dependents.
  </span>,
  <span>
    <span className='font-semibold'>The vision checks can be availed at home, diagnostic center or a camp</span> can be
    set up at your office premises.
  </span>,
];

const DENTAL_LOCK_CONTENT = [
  <span>
    <span className='font-semibold'>Save up-to 40% on dental checks</span> & create customized packages for your
    employees and dependents.
  </span>,
  <span>
    <span className='font-semibold'>The dental checks can be availed at home, diagnostic center or a camp</span> can be
    set up at your office premises.
  </span>,
];

const COVID_VACCINATION_LOCK_CONTENT = [
  <span>
    <span className='font-semibold'>Save up-to 40% on covid vaccination </span> & create customized packages for your
    employees and dependents.
  </span>,
  <span>
    <span className='font-semibold'>The covid vaccination can be availed at home, diagnostic center or a camp</span> can be
    set up at your office premises.
  </span>,
];

const FLU_VACCINATION_LOCK_CONTENT = [
  <span>
    <span className='font-semibold'>Save up-to 40% on flu vaccination </span> & create customized packages for your
    employees and dependents.
  </span>,
  <span>
    <span className='font-semibold'>The flu vaccination can be availed at home, diagnostic center or a camp</span> can be
    set up at your office premises.
  </span>,
];

const SPECIALIST_CONSULTATION_LOCK_CONTENT = [
  <span>
    <span className='font-semibold'>Save up-to 40% on online consultation </span> & create customized packages for your
    employees and dependents.
  </span>,
  <span>
    <span className='font-semibold'>The specialist consultation can be availed online</span> can be
    set up at your office premises.
  </span>,
];

const OCCUPATIONAL_MEDICAL_ROOMS_LOCK_CONTENT = [
  <span>
    <span className='font-semibold'>Save up-to 40% on medical rooms </span> & create customized packages for your
    employees and dependents.
  </span>
];

const CANCER_SCREENING_LOCK_CONTENT = [
  <span>
    <span className='font-semibold'>Save up-to 40% on cancer screening </span> & create customized packages for your
    employees and dependents.
  </span>,
  <span>
    <span className='font-semibold'>The cancer screening can be availed at diagnostic center or a camp</span> can be
    set up at your office premises.
  </span>,
];

const FERTILITY_TREATMENT_LOCK_CONTENT = [
  <span>
    <span className='font-semibold'>Save up-to 40% on fertility treatment </span> & create customized packages for your
    employees and dependents.
  </span>,
  <span>
    <span className='font-semibold'>The fertility treatment can be availed at diagnostic center or a camp</span> can be
    set up at your office premises.
  </span>,
];

const INCLINIC_CONSULTATION_LOCK_CONTENT = [
  <span>
    <span className='font-semibold'>Save up-to 40% on inclinic consultation </span> & create customized packages for your
    employees and dependents.
  </span>,
  <span>
    <span className='font-semibold'>The inclinic consulation can be availed at diagnostic center or a camp</span> can be
    set up at your office premises.
  </span>,
];

const PRE_EMPLOYMENT_LOCK_CONTENT = [
  <span>
    <span className='font-semibold'>Save up-to 40% on pre employment checkup </span> & create customized packages for your
    employees and dependents.
  </span>,
  <span>
    <span className='font-semibold'>The pre employment can be availed at home, diagnostic center or a camp</span> can be
    set up at your office premises.
  </span>,
];

const BENEFIT_LOCK_CONTENT = [
  <span>
    <span className='font-semibold'>Save up-to 40% on treatment</span> & create customized packages for your
    employees and dependents.
  </span>,
  <span>
    <span className='font-semibold'>The treatment can be availed at diagnostic center or a camp</span> can be
    set up at your office premises.
  </span>,
];

const DOCTOR_CONSULTATION_LOCK_CONTENT = [
  <span>
    <span className='font-semibold'>20+ MBBS qualified doctors</span> available for online chat around the clock for any
    medical query or diagnosis.
  </span>,
  <span>
    <span className='font-semibold'>Connect with the doctor within 30 seconds</span> & get answers to all health related
    queries from anywhere, anytime.
  </span>,
  <span>
    <span className='font-semibold'>Access to MCI certified Family Doctors</span> for customized health consultations as
    per the family medical history, available for all employees & their dependants.
  </span>,
];
const HRA_LOCK_CONTENT = [
  <span>
    Know the overall health performance of your employees on a <span className='font-semibold'>real-time basis</span> to
    identify any potential health risks on time.
  </span>,
  <span>
    Guide employees in taking/re-taking HRA to{' '}
    <span className='font-semibold'>track their collective health risk data</span> & get your organization’s average
    wellness score.
  </span>,
  <span>
    <span className='font-semibold'>Use organized analytical data</span> based on periodical HRAs to customize employee
    wellness programs that better suit their requirements.
  </span>,
];

const VACCINATION_LOCKED_CONTENT = [
  <span>
    Enable cashless vaccination appointments across our partner network in{' '}
    <span className='font-semibold'>50+ cities.</span>
  </span>,
  <span>
    <span className='font-semibold'>Organize onsite camps </span>
    for innoculation at your workplace or offer <span className='font-semibold'>at-home administration </span>
    through our partner phlebotomists.
  </span>,
  <span>
    <span className='font-semibold'>COVID-19, Influenza, Typhoid or HPV </span>
    vaccines can be provided through ekincare as part of your corporate health benefits program.
  </span>,
];

const FITNESS_LOCKED_CONTENT = [
  <span>
    Unlimited access to <span className='font-semibold'>3000+ popular fitness studios </span>
    pan India.
  </span>,
  <span>
    <span className='font-semibold'> Over 21+ fun & exciting sessions </span>
    including Zumba, Cross-fit, Swimming, Yoga, Pilates, etc. to make fitness enjoyable.
  </span>,
  <span>
    Enjoy the <span className='font-semibold'>flexibility of location and services.</span>
  </span>,
];

const HEALTH_COACH_LOCKED_CONTENT = [
  <span>Introduce gamified wellness programs in the workplace to increase employee engagement.</span>,
  <span>
    Track your employees’ chronic conditions like diabetes, hypertension, obesity & also get professional help during
    pregnancy through customized health plans & coaching.
  </span>,
  <span>Get access to Doctors, Nutritionists, Fitness experts, Life coaches, & get customized health tips.</span>,
];

const PHARMACY_LOCKED_CONTENT = [
  <span>
    <span className='semibold'>Up to 20% off</span> on orders above Rs.500. No minimum order value required to place an
    order.
  </span>,
  <span>
    <span className='semibold'>Consult in-house MBBS doctors</span> for any medicine-related query or to generate a
    valid prescription anytime.
  </span>,
  <span>
    Serving <span className='semibold'>more than 25000 pin codes</span> with an option of cash on delivery.{' '}
  </span>,
];

const FILTER = {
  Departments: { filter: 'department', xAxesLabel: 'Departments' },
  Location: { filter: 'location', xAxesLabel: 'Location' },
  Age: { filter: 'age', xAxesLabel: 'Age' },
  Gender: { filter: 'gender', xAxesLabel: 'Gender' },
};

const TOTAL_GYMS = 'TOTAL_GYMS';
const TOTAL_AHC = 'TOTAL_HEALTH_CHECKS';
const TOTAL_VISION = 'TOTAL_VISION';
const TOTAL_DENTAL = 'TOTAL_DENTAL';
const TOTAL_COVID_VACCINATION = 'TOTAL_COVID_VACCINATION';
const TOTAL_FLU_VACCINATION = 'TOTAL_FLU_VACCINATION';
const TOTAL_SPECIALIST_CONSULTATION = 'TOTAL_SPECIALIST_CONSULTATION';
const TOTAL_OCCUPATIONAL_MEDICAL_ROOMS = 'TOTAL_OCCUPATIONAL_MEDICAL_ROOMS';
const TOTAL_CANCER_SCREENING = 'TOTAL_CANCER_SCREENING';
const TOTAL_PRE_EMPLOYMENT ='TOTAL_PRE_EMPLOYMENT'
const TOTAL_FERTILITY_TREATMENT = 'TOTAL_FERTILITY_TREATMENT';
const TOTAL_INCLINIC_CONSULTATION = 'TOTAL_INCLINIC_CONSULTATION';
const TOTAL_VACCINATIONS = 'total_vaccinations';
const TOTAL_SPENDING_ACCOUNT ='TOTAL_SPENDING_ACCOUNT'
const TOTAL = 'TOTAL'

export {
  HEALTH_CHECKS_LOW,
  DOCTOR_CONSULTATION_LOW,
  HEALTH_COACH_LOW,
  FITNESS_LOW,
  VACCINATION_LOW,
  PHARMACY_LOW,
  HRA_LOW,
  AHC_LOCK_CONTENT,
  DOCTOR_CONSULTATION_LOCK_CONTENT,
  HRA_LOCK_CONTENT,
  FITNESS_LOCKED_CONTENT,
  HEALTH_COACH_LOCKED_CONTENT,
  VACCINATION_LOCKED_CONTENT,
  PHARMACY_LOCKED_CONTENT,
  ACTIVITY_INITIAL_STATE,
  TOTAL_GYMS,
  TOTAL_AHC,
  TOTAL_VACCINATIONS,
  FILTER,
  TOTAL_SPENDING_ACCOUNT,
  DENTAL_LOW,
  VISION_LOW,
  VISION_LOCK_CONTENT,
  DENTAL_LOCK_CONTENT,
  TOTAL_VISION,
  TOTAL_DENTAL,
  COVID_VACCINATION_LOCK_CONTENT,
  FLU_VACCINATION_LOCK_CONTENT,
  SPECIALIST_CONSULTATION_LOCK_CONTENT,
  OCCUPATIONAL_MEDICAL_ROOMS_LOCK_CONTENT,
  CANCER_SCREENING_LOCK_CONTENT,
  FERTILITY_TREATMENT_LOCK_CONTENT,
  INCLINIC_CONSULTATION_LOCK_CONTENT,
  PRE_EMPLOYMENT_LOCK_CONTENT,
  BENEFIT_LOCK_CONTENT,
  TOTAL_COVID_VACCINATION,
  TOTAL_FLU_VACCINATION,
  TOTAL_SPECIALIST_CONSULTATION,
  TOTAL_OCCUPATIONAL_MEDICAL_ROOMS,
  TOTAL_CANCER_SCREENING,
  TOTAL_FERTILITY_TREATMENT,
  TOTAL_INCLINIC_CONSULTATION,
  TOTAL_PRE_EMPLOYMENT,
  TOTAL
};
